import { createContext, useContext } from "react";
import { Path } from "react-router-dom";

export const LocationContext = createContext<Path | null>(null);

export function useAppLocation() {
  const location = useContext(LocationContext);
  if (!location) {
    throw new Error(
      "useAppLocation must be used within a LocationContext Provider"
    );
  }
  return location;
}
